document.addEventListener('DOMContentLoaded', function () {
  var statusPanels = document.querySelectorAll('.status-panel');
  statusPanels.forEach(function (panel) {
    panel.addEventListener('click', function (e) {
      e.preventDefault();
      var href = e.target.closest('.card.status-panel').dataset.href;
      if (href) {
        window.location = href;
      }
    });
  });
});